<div style="padding-top: 30px;"></div>
<div class="tab-pane" role="tabpanel" id="tiposol">
    <fieldset id="agregar_tiposol" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <div class="alert alert-danger" role="alert" id="tp_find_alert" name="tp_find_alert" hidden>
                        <i class="fa fa-exclamation-triangle fa-2x" aria-hidden="true"></i>
                        <span id="tp_dir_message"></span>
                    </div>

                    <div class="form-horizontal titulo">

                       <!--  <div class="form-group" align="left" *ngIf="acotado">
                            <label class="col-sm-2" style="padding-top: 20px;">Tipo de solicitud</label>
                            <mat-form-field class="example-chip-list" class="col-sm-6">
                                <mat-chip-list #chipList aria-label="Fruit selection">
                                    <mat-chip *ngFor="let sol of sols" [selectable]="selectable" [removable]="removable"
                                        (removed)="remove(sol)">
                                        {{sol.optradio}}
                                        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                                    </mat-chip>
                                    <input placeholder="Tipo de solicitud" [matChipInputFor]="chipList"
                                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                        [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="add($event)">
                                </mat-chip-list>
                            </mat-form-field>
                        </div> -->




                        <!--   <div class="form-group" align="left" *ngIf="!acotado">

                            <div class="col-sm-3" class="inline" style="font-size: 13px">
                                <div class="col-md-4">
                                    <mat-checkbox (change)="add_tipo_solicitud()"
                                        [(ngModel)]="solicitud['AMPLIACIÓN MENOR A 100 M2']">AMPLIACIÓN MENOR A 100 M2
                                    </mat-checkbox>
                                </div>
                                <div class="col-md-4">
                                    <mat-checkbox (change)="add_tipo_solicitud()"
                                        [(ngModel)]="solicitud['MODIFICACIÓN']" name="optradio">MODIFICACIÓN (Sin
                                        alterar estructura)</mat-checkbox>
                                </div>
                                <div class="col-md-4">
                                    <mat-checkbox (change)="add_tipo_solicitud()"
                                        [(ngModel)]="solicitud['ART 6 2 9 OGUC']" name="optradio">ART 6.2.9 O.G.U.C
                                    </mat-checkbox> -->
                        <div class="form-group" align="left" *ngIf="!acotado">
                            <form [formGroup]="formchecks">

                                <div class="col-sm-3" class="inline" style="font-size: 13px">
                                    <div class="col-md-4">
                                        <mat-checkbox (change)="add_tipo_solicitud()" formControlName="solicitud1"
                                            id="solicitud1" name="solicitud1">AMPLIACIÓN MENOR A 100 M2</mat-checkbox>
                                    </div>
                                    <div class="col-md-4">
                                        <mat-checkbox (change)="add_tipo_solicitud()" formControlName="solicitud2"
                                            id="solicitud2" name="solicitud2">MODIFICACIÓN (Sin alterar estructura)
                                        </mat-checkbox>
                                    </div>
                                    <div class="col-md-4">
                                        <mat-checkbox (change)="add_tipo_solicitud()" formControlName="solicitud3"
                                            id="solicitud3" name="solicitud3">ART 6.2.9 O.G.U.C</mat-checkbox>
                                    </div>
                                </div>


                                <div class="col-sm-2"></div>
                            </form>
                        </div>
                    </div>

                    <br>
                </div>

            </div>
        </div>
    </fieldset>
</div>
<div class="separator"></div>